<script>
import HelpersMixin from "./HelpersMixin";

export default {
  mixins: [HelpersMixin],
  methods: {
    getComments(elementUuid, submissionUuid) {
      if (!elementUuid) {
        return [];
      }
      return this.getToken().then((token) => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", token);
        return fetch(
          "/jsonapi/catch_comment/catch_comment?include=user,attached_file&filter[element_uuid]=" +
            elementUuid +
            "&filter[submission_uuid]=" +
            (submissionUuid ? submissionUuid : this.submissionUuid),
          {
            credentials: "include",
            method: "GET",
            headers: fetch_headers,
          }
        )
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            let included = {};
            if (json.included) {
              json.included.forEach((data) => {
                included[data.id] = data;
              });
            }
            let comments = json.data.map((comment) => {
              let userUuid = comment.relationships.user.data.id;
              let files =
                comment.relationships.attached_file &&
                comment.relationships.attached_file.data
                  ? comment.relationships.attached_file.data
                  : null;
              let user = included[userUuid];

              comment.files = [];
              if (files) {
                files.map((file) => {
                  comment.files.push(included[file.id]);
                });
              }
              comment.user = user;

              comment.canDelete =
                window.drupalSettings.user.uid ==
                  user.attributes.drupal_internal__uid ||
                window.drupalSettings.user.uid == 1 ||
                (userUuid == window.drupalSettings.user.uuid &&
                  comment.attributes.parent_id == 0);

              return comment;
            });
            return comments;
          });
      });
    },
    setComment(elementUuid, comment, meta, comment_uuid) {
      this.loading = true;
      return this.getToken().then((token) => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", token);
        let method = "POST";
        fetch("/jsonapi/catch_comment/catch_comment", {
          credentials: "include",
          method: method,
          headers: fetch_headers,
          body: JSON.stringify({
            data: {
              type: "catch_comment--catch_comment",
              id: comment_uuid,
              attributes: {
                element_uuid: elementUuid,
                submission_uuid: this.submissionUuid,
                comment: comment,
                entity_type: this.entity_type,
                entity_id: this.entity_id,
                meta: JSON.stringify(meta),
                uuid: comment_uuid,
              },
            },
          }),
        })
          .then((response) => {
            return response.json();
          })
          .then(() => {
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    deleteComment(commentId) {
      this.loading = true;
      return this.getToken()
        .then((token) => {
          let fetch_headers = new Headers();
          fetch_headers.append("Content-Type", "application/vnd.api+json");
          fetch_headers.append("X-CSRF-Token", token);
          let method = "DELETE";
          return fetch("/jsonapi/catch_comment/catch_comment/" + commentId, {
            credentials: "include",
            method: method,
            headers: fetch_headers,
          });
        })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deleteAnnotation(elementUuid, annotationUuid) {
      let url = `/catch_comment/delete/${elementUuid}/${annotationUuid}`;
      return this.getToken()
        .then((token) => {
          let fetch_headers = new Headers();
          fetch_headers.append("Content-Type", "application/vnd.api+json");
          fetch_headers.append("X-CSRF-Token", token);
          let method = "POST";
          return fetch(url, {
            credentials: "include",
            method: method,
            headers: fetch_headers,
          });
        })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getSubmission() {
      if (!window.drupalSettings.form_builder) {
        return {};
      }
      let nuuid = Object.keys(window.drupalSettings.form_builder)[0];
      let uuid = this.submissionUuid || this.sid;
      let submission =
        window.drupalSettings.form_builder[nuuid].submissions[uuid];
      return submission ? submission : {};
    },
  },
  data() {
    return {
      loading: false,
      player: {},
      plugin: {},
      comments: {},
      nid: window.drupalSettings.node ? window.drupalSettings.node.uuid : null,
      submissionUuid:
        window.drupalSettings.activitySubmissionUuid ||
        this.getSubmission().uuid,
      entity_type:
        window.drupalSettings.entityType ||
        this.getSubmission().entity_type ||
        null,
      entity_id:
        window.drupalSettings.entityId ||
        this.getSubmission().entity_id ||
        null,
    };
  },
};
</script>
